import { Component, Inject, Renderer2 } from '@angular/core';
import * as AOS from 'aos';

import { Title, Meta } from '@angular/platform-browser';

import { Constants } from '../../common/constants';
import { DOCUMENT } from '@angular/common';
import { SeoService } from 'src/app/common/seo.service';
@Component({
  selector: 'app-migrate-cloud-blog',
  templateUrl: './migrate-cloud-blog.component.html',
  styleUrls: ['./migrate-cloud-blog.component.css']
})
export class MigrateCloudBlogComponent {
  constructor(
    private titleService: Title,private seoService:SeoService,
    private metaService: Meta, private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document,
  ) {}
  baseUrl=Constants.baseUrl;
  ngOnInit(): void {
    let script = this._renderer2.createElement('script');
    script.type = `application/ld+json`;
    script.text = `
{
  "@context": "https://schema.org",
  "@type": "BlogPosting",
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": "https://mitresource.com/migrate-cloud/"
  },
  "headline": "Why is Cloud migration critical in the COVID-19 scenario",
  "description": "In just a few months, COVID19 had brought about years of change in the way businesses operate. It has pushed businesses to uncertainties that brought negative impact in terms of risks, closures, maintenance, operations, making several businesses financially fragile and at the edge of risk.",
  "image": "https://mitresource.com/assets/images/blogs/cloudmigrationblog.webp",  
  "author": {
    "@type": "Organization",
    "name": "Maganti IT Resources",
    "url": "https://mitresource.com/"
  },  
  "publisher": {
    "@type": "Organization",
    "name": "Maganti IT",
    "logo": {
      "@type": "ImageObject",
      "url": "https://mitresource.com/assets/images/homepage/update-mitimage.png"
    }
  },
  "datePublished": "2022-11-11"
}`;
   
    this._renderer2.appendChild(this._document.head, script);
    this.setTitleAndMetaTags();
    this.seoService.createLinkForCanonicalURL();
  }
  private setTitleAndMetaTags(): void {
    this.titleService.setTitle('Why is Cloud migration critical in the COVID-19 scenario');

    this.metaService.addTags([
      { name: 'description', content: 'In just a few months, COVID19 had brought about years of change in the way businesses operate!' },
      { property: 'og:type', content: 'website' },
      { property: 'og:title', content: 'Why is Cloud migration critical in the COVID-19 scenario' },
      { property: 'og:url', content: 'https://mitresource.com/migrate-cloud/' },
      { property: 'og:image', content: 'https://mitresource.com/assets/images/blogs/cloudmigrationblog.webp' },
      { property: 'og:description', content: 'In just a few months, COVID19 had brought about years of change in the way businesses operate.' },
    ]);
  }
}

